/**
 * Enum with types of work areas (firm, user, e.t.c)
 */
export enum AreaTypeEnum {
  FIRM = 'firm',
  // @TODO client
  CLIENT = 'client'
}
